module.exports = __webpack_public_path__ + "static/mintifi-9c1f951c324702d6558e160ac51edbef.jpg";